import Timer from './components/Timer/Timer';
import getTimeParts from './lib/helpers/getTimeParts';
import { useTimer } from './hook/useTimer';
export * from './types';
export { getTimeParts, useTimer, };
export default Timer;
//# sourceMappingURL=index.js.map